import moment from 'moment';
import { getSubOrderStatuses } from '../../HttpRequests/subOrderStatuses';
import { loadSubOrderStatuses } from '../State/subOrderStatuses';

let lastGetTimestamp = null;

export default () => async (dispatch) => {

  try {

    const now = Number(moment().format('x'));

    if (lastGetTimestamp && now - lastGetTimestamp < 60000) {
      return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const response = await getSubOrderStatuses();

    dispatch(loadSubOrderStatuses(response.data.data));

  } catch (error) {
    console.error(error);
  }

}
